module.exports = "/*STICKY FOOTER*/\r\n.sign-wrap{\r\n\t/* minus sizes of hero, footer*/\r\n\tmin-height: calc(100vh - 280px);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/authentication/pages/sign-out-page/sign-out-page.component.css
// module id = ./src/app/core/authentication/pages/sign-out-page/sign-out-page.component.css
// module chunks = main